import axios, {AxiosResponse} from 'axios'
import {
  TransactionsQueryResponse,
} from './_models'

const BASE_URL = '/p2c/payment/transactions'

// Transactions
const getTransactions = (query?: string): Promise<TransactionsQueryResponse> => {
  return axios
    .get(`${BASE_URL}?${query}`)
    .then((d: AxiosResponse<TransactionsQueryResponse>) => {
      return d.data
    })
}

export {
  getTransactions
}
